import { createContext } from 'react';
import type { ViewTransitionContextType } from './ViewTransitionProvider';

export const ViewTransitionContext = createContext<ViewTransitionContextType | undefined>(undefined);